import { Log } from '@/types/logs'
import { checkIsLogUnfinished } from './checkIsLogUnfinished'

export const checkLockPermissions = (log: Log): boolean => {
    if (log.isLocked) {
        return log.codingPeriodInfo.permissions.includes('Unlock')
    } else {
        return log.codingPeriodInfo.permissions.includes('Lock') && !checkIsLogUnfinished(log)
    }
}
